export default {
  user: {},
  isOnLine: {},
};
